import { forwardRef } from 'react';
import { oneLine } from 'common-tags';

import { Spinner } from '@/icons';

import '@/lib/utils/forwardRef';
import styles from './Button.module.css';

import type { ButtonProps } from './types';

/**
 * Primary UI component for user interaction
 */
const ButtonBase = <T extends React.ElementType = 'button'>(
  {
    className = '',
    as,
    style = 'primary',
    disabled = false,
    size = 'normal',
    negative = false,
    icon = null,
    label,
    loading = false,
    ...props
  }: ButtonProps<T> &
    Omit<React.ComponentPropsWithRef<T>, keyof ButtonProps<T>>,
  ref: React.Ref<any>
) => {
  const HTMLTag = as || 'button';

  return (
    <HTMLTag
      className={oneLine`
        ${styles['o-button']} 
        ${styles[`o-button--${size}`]}
        ${styles[`o-button--${style}${negative ? '-negative' : ''}`]}
        ${disabled ? styles['o-button--disabled'] : ''}
        ${className}
      `}
      disabled={disabled}
      ref={ref}
      {...props}
    >
      {loading ? (
        <Spinner className="animate-spin motion-reduce:hidden" />
      ) : (
        <>
          {label}
          {icon}
        </>
      )}
    </HTMLTag>
  );
};

export const Button = forwardRef(ButtonBase);
